<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="12" md="10">
        <CardSplit
          version="v1"
          :img="{
            src: imgSrc,
          }"
          max-width="1200px"
        >
          <template #header>
            <v-container fluid>
              <v-row justify="center" no-gutters>
                <v-col cols="12" class="d-flex flex-column align-center mt-16">
                  <BaseLogo version="v2" class="mb-10" />
                  <template v-if="!recoverCompleted">
                    <h1 class="text-h1 text-center mb-4">Recupera tu contraseña</h1>

                    <p class="text-body-2">Escribe el email asociado a tu cuenta</p>
                  </template>
                  <template v-else>
                    <h1 class="text-h1 text-center mb-4">Te enviamos un email</h1>

                    <p class="text-body-2 text-center">
                      Ya recibiste un correo con instrucciones para restaurar tu
                      contraseña
                    </p>
                  </template>
                </v-col>
              </v-row>
            </v-container>
          </template>

          <v-container>
            <v-row justify="center">
              <v-col cols="12" md="8">
                <v-form
                  v-if="!recoverCompleted"
                  ref="formRef"
                  v-model="form.isValid"
                  class="recover__form mx-auto form"
                  @submit.prevent="onSubmit"
                >
                  <v-text-field
                    v-model="form.email"
                    class="mb-4 rounded-md"
                    light
                    outlined
                    dense
                    label="Ingresa tu email"
                    type="email"
                    data-test="input-email"
                    :rules="rules.email"
                  />
                  <v-btn
                    class="rounded-md mb-2"
                    type="submit"
                    block
                    data-test="button-submit"
                    :loading="isLoading"
                    :disabled="!form.isValid"
                  >
                    Continuar
                  </v-btn>
                </v-form>

                <template v-else>
                  <v-btn
                    class="rounded-md my-16"
                    :to="{ name: 'Home' }"
                    type="submit"
                    block
                    data-test="button-home"
                    :loading="isLoading"
                  >
                    Iniciar sesión
                  </v-btn>
                </template>
              </v-col>
            </v-row>
          </v-container>
        </CardSplit>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { reactive, ref } from "vue";
import { createClient } from "@/vue-apollo";
import store from "@/store";
import { isRequired, isEmail } from "../lib/validators";
import CardSplit from "@/components/Base/CardSplit";
import BaseLogo from "@/components/Base/Logo";

export default {
  name: "RecoverPage",

  components: {
    BaseLogo,
    CardSplit,
  },

  metaInfo() {
    return {
      title: "Recupera tu contraseña",
    };
  },

  setup() {
    const isLoading = ref(false);

    // CardSplit
    const hasError = ref(false);
    const errorMessage = ref("Hubo un problema. Por favor intentalo más tarde.");
    const imgSrc =
      process.env.VUE_APP_ASSETS_BASE_PATH +
      "yourney/assets/recover-password-split.png";

    // Modal
    const recoverCompleted = ref(false);

    // Form
    const form = reactive({
      email: "",
      isValid: true,
    });
    const rules = {
      email: [isRequired, isEmail()],
    };
    const onSubmit = async () => {
      try {
        if (!form.isValid) return;
        isLoading.value = true;
        await store.dispatch("users/recover", {
          email: form.email,
          apolloClient: createClient(),
        });
        recoverCompleted.value = true;
      } catch (error) {
        console.error(error);
        hasError.value = true;
      } finally {
        isLoading.value = false;
      }
    };

    return {
      errorMessage,
      form,
      hasError,
      isLoading,
      imgSrc,
      onSubmit,
      recoverCompleted,
      rules,
    };
  },
};
</script>

<style lang="scss" scoped>
.recover {
  min-height: 812px;
  &__form {
    width: 100%;
    max-width: 360px;
    &-field {
      fieldset {
        color: blue;
      }
    }
  }
}
</style>
